/* eslint-disable */
import { Card, CardContent, Box, InputAdornment } from '@mui/material';
import React from 'react';
import {
    Datagrid,
    TextField,
    TextInput,
    ReferenceInput,
    AutocompleteInput,
    ReferenceField,
    Filter,
    Button,
    ResourceContextProvider,
    NullableBooleanInput,
    useListContext,
    useDataProvider,
    Loading,
    useRecordContext,
    List
} from 'react-admin';
import { CloneButton } from '../../../lib/wrappers/actions';
import { useAzureADGroups } from '../../../msal/useAzureADGroups';
import { QualificationList } from '../QualificationList';
import { ReadOnlyContext } from '../../../lib/context/ReadOnlyContext';
import { CourseFilterSidebar } from './CourseFilterSidebar';
import { SwList } from '../../../lib/SwList';


export const RedirectToEditButtonNewWindow = ({  label, source, ...props }) => {
    const record = useRecordContext();
   return <Button label={label} variant="outlined" onClick={() => window.open(`/#/Course/${record.id}`, '_blank')} />; 
 };

const CourseSearch = (props) => {
    const { canEditCourseAndModule } = useAzureADGroups();
    return (
        <>
            <ReadOnlyContext.Provider value={!canEditCourseAndModule}>
                    <SwList {...props} aside={<CourseFilterSidebar />}  filterDefaultValues={{isClosed: false}} >
                    <Datagrid
                        rowClick={false}
                        bulkActionButtons={!canEditCourseAndModule ? false : undefined}
                        >
                        <TextField source="id" />
                        <TextField source="Title" />
                        <QualificationList label="Qualification" />
                        <ReferenceField
                            reference="Status"
                            source="statusId"
                            link="show">
                            <TextField source="Title" />
                        </ReferenceField>
                        <ReferenceField
                            reference="CourseLevel"
                            source="courseLevelId"
                            link="show">
                            <TextField source="Title" />
                        </ReferenceField>
                        <RedirectToEditButtonNewWindow  label={canEditCourseAndModule ? "Edit" : "View"} {...props} />
                        <CloneButton label="myroot.copy" />
                    </Datagrid>
                </SwList>
            </ReadOnlyContext.Provider>
        </>
    );
};



export default CourseSearch;


